import { Lead } from 'models/Lead';
import { User } from 'models/User';
import { DataRoom } from './DataRoom';
import { QAndARoles, QAndASides } from './QAndA';
import { ObjectValues } from 'types';
import { DataRoomDashboardTimeframe } from './Dashboard';
import { AnalyticsTimeframe } from '../subrouters/Reports/pages/Reports/types';

export const DATA_ROOM_MEMBER_ROLES = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  PUBLISHER: 'Publisher',
  VIEWER_DOWNLOADER: 'ViewerDownloader',
  VIEWER: 'Viewer',
} as const;

export type DataRoomMemberRole = ObjectValues<typeof DATA_ROOM_MEMBER_ROLES>;

export type DataRoomMembers = {
  sellSideMembers: DataRoomMember[];
  buySideGroups: DataRoomBuySideGroup[];
};

export type DataRoomMember = Pick<User, 'firstName' | 'lastName' | 'email'> & {
  _id: string;

  userId: string;

  canRevoke?: boolean;
  lastAccessNodeAt?: Date; // last time that user access Data room node

  role: DataRoomMemberRole;
  dataRoomId: string;
  leadId: string;
  user: Partial<User> | null;
  dataRoom: Partial<DataRoom> | null;
  lead: Partial<Lead> | null;
  isSetup: boolean;
  isAccepted: boolean;
  uploadedFileIds: string[]; // files that user has uloaded
  accessableDataRoomNodesView: string[];
  accessableDataRoomNodesDownload: string[];
  qaRole: QAndARoles;
  qaSide: QAndASides;
  teams: string[];
  isLead?: boolean;
  numberOfViewedFiles: number;
  isEnterpriseHead?: boolean;
  requestedDataRoomAccess?: boolean;
  requestedDataRoomAccessAt?: Date;
  sessionId?: string;

  showConfirmFileInterestBanner?: boolean; // display banner to confirm file access interest

  hasFullAccess?: boolean; // has access to all files in data room
  hasFullDownloadAccess?: boolean; //has download access to all files in data room

  //virtual
  hasAccessToOwnFiles: boolean;
  canExtendAccess?: boolean;

  useMessaging?: boolean; // can use in-platform messaging

  filesAccessExpiredAt?: Date; // date when file access expires

  isPrefferedSummarisedView?: boolean;
  preferredDashboardTimeframe?: DataRoomDashboardTimeframe;

  preferredAnalyticsTimeframe?: AnalyticsTimeframe;
};

export type DataRoomBuySideGroup = {
  _id: string;

  name: string;

  dataRoomMemberIds: string[];
  dataRoomMembers: DataRoomMember[];
  autoApproveQuestions?: boolean;
  hasQuestionsInReview?: boolean;
};
